import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Columns3 } from 'lucide-react';
import { ALL_ROLE_COLUMNS, COLUMN_LABELS } from '../types';
import type { RoleColumnKey } from '../types';

interface ColumnVisibilityToggleProps {
  visibleColumns: RoleColumnKey[];
  onVisibleColumnsChange: (columns: RoleColumnKey[]) => void;
}

export function ColumnVisibilityToggle({
  visibleColumns,
  onVisibleColumnsChange,
}: ColumnVisibilityToggleProps) {
  const { t } = useTranslation('roles');

  const toggleColumn = (col: RoleColumnKey) => {
    // roleId is always visible
    if (col === 'roleId') return;
    if (visibleColumns.includes(col)) {
      onVisibleColumnsChange(visibleColumns.filter((c) => c !== col));
    } else {
      onVisibleColumnsChange([...visibleColumns, col]);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Columns3 className="h-4 w-4 mr-1" />
          {t('toolbar.columns')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {ALL_ROLE_COLUMNS.map((col) => (
          <DropdownMenuCheckboxItem
            key={col}
            checked={visibleColumns.includes(col)}
            onCheckedChange={() => toggleColumn(col)}
            disabled={col === 'roleId'}
          >
            {t(COLUMN_LABELS[col], col)}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
